import * as React from 'react'

import { Alert } from 'main/ui'
import { IPageAlert } from 'main/util/page'
import { Container } from './PageAlert.styles'

interface IProps extends IPageAlert {
  onDismiss: () => void
}

export default function PageAlert(props: IProps) {
  const { kind, body, onDismiss } = props

  return (
    <Container>
      <Alert kind={kind} onDismiss={onDismiss}>
        {body}
      </Alert>
    </Container>
  )
}
